import SvgIcon from '@/components/SvgIcon/index.vue'

const svgRequired = require.context('./svg', false, /\.svg$/)
svgRequired.keys().forEach((item) => svgRequired(item))
const svgIcon = (app: any) => {
  app.component('svg-icon', SvgIcon)
}
export default svgIcon
